export default {"src":"__ASTRO_ASSET_IMAGE__B2X4AC8$__","width":264,"height":192,"format":"svg"}